/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CategorieTypeEvacuationDto } from '../models/categorie-type-evacuation-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des catégories de types d'évacuation
 */
@Injectable({
  providedIn: 'root',
})
export class CategoriesTypesEvacuationsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation categorieTypeEvacuationGetList
   */
  static readonly CategorieTypeEvacuationGetListPath = '/api/categories-types-evacuations/list/{typeEvacuationId}';

  /**
   * Renvoie la liste des catégories du type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieTypeEvacuationGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieTypeEvacuationGetList$Response(params: {

    /**
     * Identifiant du type d&#x27;évacuation
     */
    typeEvacuationId: number;
  }): Observable<StrictHttpResponse<Array<CategorieTypeEvacuationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesTypesEvacuationsService.CategorieTypeEvacuationGetListPath, 'get');
    if (params) {
      rb.path('typeEvacuationId', params.typeEvacuationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CategorieTypeEvacuationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des catégories du type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieTypeEvacuationGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieTypeEvacuationGetList(params: {

    /**
     * Identifiant du type d&#x27;évacuation
     */
    typeEvacuationId: number;
  }): Observable<Array<CategorieTypeEvacuationDto>> {

    return this.categorieTypeEvacuationGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CategorieTypeEvacuationDto>>) => r.body as Array<CategorieTypeEvacuationDto>)
    );
  }

  /**
   * Path part for operation categorieTypeEvacuationLoadList
   */
  static readonly CategorieTypeEvacuationLoadListPath = '/api/categories-types-evacuations/load-list/{typeEvacuationId}';

  /**
   * Renvoie la liste des catégories du type d'évacuation spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieTypeEvacuationLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieTypeEvacuationLoadList$Response(params: {

    /**
     * Identifiant du type d&#x27;évacuation
     */
    typeEvacuationId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesTypesEvacuationsService.CategorieTypeEvacuationLoadListPath, 'post');
    if (params) {
      rb.path('typeEvacuationId', params.typeEvacuationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des catégories du type d'évacuation spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieTypeEvacuationLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieTypeEvacuationLoadList(params: {

    /**
     * Identifiant du type d&#x27;évacuation
     */
    typeEvacuationId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.categorieTypeEvacuationLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation categorieTypeEvacuationGet
   */
  static readonly CategorieTypeEvacuationGetPath = '/api/categories-types-evacuations/{id}';

  /**
   * Renvoie la catégorie de type d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieTypeEvacuationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieTypeEvacuationGet$Response(params: {

    /**
     * Identifiant du matériel
     */
    id: number;
  }): Observable<StrictHttpResponse<CategorieTypeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesTypesEvacuationsService.CategorieTypeEvacuationGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategorieTypeEvacuationDto>;
      })
    );
  }

  /**
   * Renvoie la catégorie de type d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieTypeEvacuationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieTypeEvacuationGet(params: {

    /**
     * Identifiant du matériel
     */
    id: number;
  }): Observable<CategorieTypeEvacuationDto> {

    return this.categorieTypeEvacuationGet$Response(params).pipe(
      map((r: StrictHttpResponse<CategorieTypeEvacuationDto>) => r.body as CategorieTypeEvacuationDto)
    );
  }

  /**
   * Path part for operation categorieTypeEvacuationPut
   */
  static readonly CategorieTypeEvacuationPutPath = '/api/categories-types-evacuations/{id}';

  /**
   * Met à jour la catégorie du type d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieTypeEvacuationPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieTypeEvacuationPut$Response(params: {

    /**
     * Identifiant de la catégorie à mettre à jour
     */
    id: number;

    /**
     * Catégorie
     */
    body: CategorieTypeEvacuationDto
  }): Observable<StrictHttpResponse<CategorieTypeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesTypesEvacuationsService.CategorieTypeEvacuationPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategorieTypeEvacuationDto>;
      })
    );
  }

  /**
   * Met à jour la catégorie du type d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieTypeEvacuationPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieTypeEvacuationPut(params: {

    /**
     * Identifiant de la catégorie à mettre à jour
     */
    id: number;

    /**
     * Catégorie
     */
    body: CategorieTypeEvacuationDto
  }): Observable<CategorieTypeEvacuationDto> {

    return this.categorieTypeEvacuationPut$Response(params).pipe(
      map((r: StrictHttpResponse<CategorieTypeEvacuationDto>) => r.body as CategorieTypeEvacuationDto)
    );
  }

  /**
   * Path part for operation categorieTypeEvacuationDelete
   */
  static readonly CategorieTypeEvacuationDeletePath = '/api/categories-types-evacuations/{id}';

  /**
   * Supprime la catégorie de type d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieTypeEvacuationDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieTypeEvacuationDelete$Response(params: {

    /**
     * Identifiant de la catégorie à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesTypesEvacuationsService.CategorieTypeEvacuationDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la catégorie de type d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieTypeEvacuationDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieTypeEvacuationDelete(params: {

    /**
     * Identifiant de la catégorie à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.categorieTypeEvacuationDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation categorieTypeEvacuationPost
   */
  static readonly CategorieTypeEvacuationPostPath = '/api/categories-types-evacuations/{typeEvacuationId}';

  /**
   * Crée la catégorie pour un type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieTypeEvacuationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieTypeEvacuationPost$Response(params: {

    /**
     * Identifiant du type d&#x27;évacuation
     */
    typeEvacuationId: number;

    /**
     * Catégorie
     */
    body: CategorieTypeEvacuationDto
  }): Observable<StrictHttpResponse<CategorieTypeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesTypesEvacuationsService.CategorieTypeEvacuationPostPath, 'post');
    if (params) {
      rb.path('typeEvacuationId', params.typeEvacuationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategorieTypeEvacuationDto>;
      })
    );
  }

  /**
   * Crée la catégorie pour un type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieTypeEvacuationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  categorieTypeEvacuationPost(params: {

    /**
     * Identifiant du type d&#x27;évacuation
     */
    typeEvacuationId: number;

    /**
     * Catégorie
     */
    body: CategorieTypeEvacuationDto
  }): Observable<CategorieTypeEvacuationDto> {

    return this.categorieTypeEvacuationPost$Response(params).pipe(
      map((r: StrictHttpResponse<CategorieTypeEvacuationDto>) => r.body as CategorieTypeEvacuationDto)
    );
  }

  /**
   * Path part for operation categorieTypeEvacuationDisable
   */
  static readonly CategorieTypeEvacuationDisablePath = '/api/categories-types-evacuations/disable/{id}';

  /**
   * Désactive la catégorie de type d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `categorieTypeEvacuationDisable()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieTypeEvacuationDisable$Response(params: {

    /**
     * Identifiant de la catégorie à mettre à jour
     */
    id: number;
  }): Observable<StrictHttpResponse<CategorieTypeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesTypesEvacuationsService.CategorieTypeEvacuationDisablePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategorieTypeEvacuationDto>;
      })
    );
  }

  /**
   * Désactive la catégorie de type d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `categorieTypeEvacuationDisable$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  categorieTypeEvacuationDisable(params: {

    /**
     * Identifiant de la catégorie à mettre à jour
     */
    id: number;
  }): Observable<CategorieTypeEvacuationDto> {

    return this.categorieTypeEvacuationDisable$Response(params).pipe(
      map((r: StrictHttpResponse<CategorieTypeEvacuationDto>) => r.body as CategorieTypeEvacuationDto)
    );
  }

}
